import { EllipsisOutlined } from '@ant-design/icons';

import AIIcon from '@/components/Badge/AIBadge/AIIcon';
import IconButton from '@/components/Button/IconButton';
import Menu from '@/components/Menu/Menu';
import AMP_KEYS from '@/configs/amp-track-keys';
import { track } from '@/utils/track/track';

type FeedbackGalleryHeaderActionsProps = {
  onClickAskSyncly: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
};

const FeedbackGalleryHeaderActions = ({
  onClickAskSyncly,
  onDuplicate,
  onDelete,
}: FeedbackGalleryHeaderActionsProps) => {
  return (
    <>
      <IconButton
        icon={<AIIcon className="text-xl" />}
        sizeType="l"
        outlined={false}
        onClick={onClickAskSyncly}
        tooltip="Create smart brief"
      />

      <Menu
        triggerNode={
          <IconButton
            icon={<EllipsisOutlined className="text-[18px]" />}
            outlined={false}
            sizeType="m"
            onClick={() => {
              track(AMP_KEYS.DASHBOARD_CARD_ELLIPSIS_CLICK);
            }}
          />
        }
        modalWidth="200px"
        options={[
          {
            label: 'Duplicate',
            onClick: onDuplicate,
          },
          {
            label: 'Remove from dashboard',
            onClick: onDelete,
          },
        ]}
      />
    </>
  );
};

export default FeedbackGalleryHeaderActions;

